
interface AppConfig {
  env: string;
  apiBaseUrl: string;
  backendUrl: string;
  odooBaseUrl: string;
  odooBackendUrl: string;
  odooDb: string;
}


export const getConfig = (): AppConfig => {
  
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
  
  // API Base URL
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 
    (env === 'production' 
      ? 'https://og.karroad.com/api' 
      : 'http://localhost:5001');

  // Backend URL
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 
    (env === 'production' 
      ? 'https://og.karroad.com' 
      : 'http://localhost:5000');

  // Odoo Base URL
  const odooBaseUrl = process.env.REACT_APP_ODOO_BASE_URL || 
    (env === 'production' 
      ? 'https://2.operacrm.com' 
      : 'https://operacrm.com');

  // Odoo Backend URL
  const odooBackendUrl = process.env.REACT_APP_ODOO_BACKEND_URL ||
    (env === 'production'
      ? 'https://ux.1.operacrm.com'
       : 'https://app.operacrm.com');

  // Odoo Database name
  const odooDb = process.env.REACT_APP_ODOO_DB || 'internal_crm';

  return {
    env,
    apiBaseUrl,
    backendUrl,
    odooBaseUrl,
    odooBackendUrl,
    odooDb,
  };
};

// Export the config as a constant (will be evaluated at build time for React)
export const config = getConfig();

// Export individual values for convenience
export const {
  env,
  apiBaseUrl,
  backendUrl,
  odooBaseUrl,
  odooBackendUrl,
  odooDb,
} = config;

